import { render, staticRenderFns } from "./angryBird.vue?vue&type=template&id=d7417a1a&scoped=true"
import script from "./angryBird.vue?vue&type=script&lang=js"
export * from "./angryBird.vue?vue&type=script&lang=js"
import style0 from "./angryBird.vue?vue&type=style&index=0&id=d7417a1a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d7417a1a",
  null
  
)

export default component.exports